
import Navigation from './App/navigation';
import { ThemeProvider, } from '@mui/material/styles';
import theme from "./App/theme";
import { Box } from '@mui/material';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Navigation />
    </ThemeProvider>
  );
}

export default App;
